import { render, staticRenderFns } from "./StudyNewPageQuestion.vue?vue&type=template&id=1e359bfa&scoped=true"
import script from "./StudyNewPageQuestion.vue?vue&type=script&lang=js"
export * from "./StudyNewPageQuestion.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageQuestion.vue?vue&type=style&index=0&id=1e359bfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e359bfa",
  null
  
)

export default component.exports